import { LOAD_TELAPERFISPORTAL, LOAD_PERFISPORTAL, LOAD_MENU } from '@/store/actions'
import { SET_PERFISPORTAL, SET_MENU } from '@/store/mutations'
import IntimacaoWebApi from "@/API/intimacaoWebApi";

export default {
    state: {
        perfisPortal: [],
        menu: []
    },
    actions: {
        [LOAD_TELAPERFISPORTAL]({ commit }) {
            return new Promise((resolve, reject) => {
                IntimacaoWebApi.getTelaPerfisPortal()
                    .then(res => {
                        if (res.data.statusCode == 200 && res.data.errorMessage == null) {
                            commit(SET_PERFISPORTAL, res.data.result);
                            resolve(res.data);
                        } else {
                            reject(res.data.errorMessage);
                        }
                    })
                    .catch(erro => {
                        reject("Erro ao pegar a lista de telaperfilPortal.");
                    });
            });
        },
        [LOAD_PERFISPORTAL]({ commit }) {
            return new Promise((resolve, reject) => {
                IntimacaoWebApi.getPerfisPortal()
                    .then(res => {
                        if (res.data.statusCode == 200 && res.data.errorMessage == null) {
                            commit(SET_PERFISPORTAL, res.data.result);
                            resolve(res.data);
                        } else {
                            reject(res.data.errorMessage);
                        }
                    })
                    .catch(erro => {
                        reject("Erro ao pegar a lista de perfilPortal.");
                    });
            });
        },
        [LOAD_MENU]({ commit }, store) {
            return new Promise((resolve, reject) => {                
                IntimacaoWebApi.carregarListaMenu({ idUsuario: store.state.auth.idUser})
                    .then(res => {
                        if (res.data.statusCode == 200 && res.data.errorMessage == null) {
                            commit(SET_MENU, res.data.result);
                            resolve(res.data);
                        } else {
                            reject(res.data.errorMessage);
                        }
                    })
                    .catch(erro => {
                        reject("Erro ao tentar carregar lista de menu.");
                    });
            });
        }
    },
    mutations: {
        [SET_PERFISPORTAL](state, payload) {
            state.perfisPortal = payload;
        },
        [SET_MENU](state, payload) {
            state.menu = payload;
        }
    }
};
